import React from "react";

const Accordion = ({ title, children, open, date }) => {
  const [isOpen, setOpen] = React.useState(open);
  return (
    <div className="ob-accordion">
      <button
        className={`ob-accordion__header ${isOpen ? "open" : ""}`}
        onClick={function (e) {
          e.preventDefault();
          setOpen(!isOpen);
        }}
      >
        <h2 className="ob-accordion__title">{title}</h2>
      </button>

      <div className={`ob-accordion__item ${!isOpen ? "collapsed" : ""}`}>
        <div
          className={`ob-accordion__content ${
            date ? "ob-accordion__content-datepicker" : ""
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
